import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';
import { WFStepStatusConfig } from 'src/app/components/workflow/workflow';
import { FormStatus } from 'src/app/services/forms/form-status';

@Component({
  selector: 'status-chips',
  templateUrl: './status-chips.component.html',
  styleUrls: ['./status-chips.component.scss'],

})
export class StatusChipsComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() statuses?: FormStatusEnum[] = [];
  @Input() stepStatusConfigs?: WFStepStatusConfig[];

  formStatuses?: FormStatus[];
  formStatusesSubs!: Subscription;

  ngOnInit(): void {
    this.loadFormStatuses();
  }

  override ngOnDestroy(): void {
    if (this.formStatusesSubs) {
      this.formStatusesSubs.unsubscribe();
    }
    super.ngOnDestroy();
  }

  loadFormStatuses() {
    this.formStatusesSubs = this.store.select(state => state.FormStatuses.data).subscribe((data: FormStatus[]) => {
      if (data?.length) {
        if (this.statuses?.length)
          this.formStatuses = data.filter(s => this.statuses?.includes(s.id));
        if (this.stepStatusConfigs?.length)
          this.formStatuses = data.filter(s => this.stepStatusConfigs?.some(c => c.status === s.id));
      }
    });
  }

}
